import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-81b8b49c")

_pushScopeId("data-v-81b8b49c")
const _hoisted_1 = { class: "p-d-flex p-flex-column" }
const _hoisted_2 = { class: "p-ml-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Tree = _resolveComponent("Tree")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Tree, {
    id: "glossary-link-tree",
    value: _ctx.nodes,
    expandedKeys: _ctx.expandedKeys
  }, {
    default: _withId((slotProps) => [
      _createVNode("div", {
        class: ["p-d-flex p-flex-row p-ai-center", { dropzone: _ctx.dropzoneActive[slotProps.node.key] }],
        onDrop: ($event: any) => (_ctx.onDragDrop($event, slotProps.node, slotProps.node.key)),
        onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        onDragenter: _withModifiers(($event: any) => (_ctx.setDropzoneClass(true, slotProps.node)), ["prevent"]),
        onDragleave: _withModifiers(($event: any) => (_ctx.setDropzoneClass(false, slotProps.node)), ["prevent"])
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", null, _toDisplayString(slotProps.node.label), 1)
        ]),
        _createVNode("div", _hoisted_2, [
          (slotProps.node.leaf)
            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "far fa-trash-alt",
                class: "p-button-link p-button-sm p-p-0",
                onClick: _withModifiers(($event: any) => (_ctx.deleteWordConfirm(slotProps.node)), ["stop"])
              }, null, 8, ["onClick"])), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.delete'),
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true)
        ])
      ], 42, ["onDrop", "onDragenter", "onDragleave"])
    ]),
    _: 1
  }, 8, ["value", "expandedKeys"]))
})